import { AppError, ErrorCode } from '../types';

export function fromPaymentError(err: any): AppError {
  const raw = String(err?.code ?? err?.message ?? '').toLowerCase();
  if (raw.includes('invalid')) return new AppError({ code: ErrorCode.PAY_INVALID, domain: 'payments', cause: err });
  return new AppError({ code: ErrorCode.PAY_DECLINED, domain: 'payments', cause: err });
}
